/* eslint-disable prettier/prettier */
import React from "react";
import PropTypes from "prop-types";
import { SubscriptionTestimonial } from "./subscription-testimonial";
// eslint-disable-next-line no-unused-vars
import { SubscriptionHelper } from "./subscription-helpers";
import { SubscriptionCollection } from "./subscription-collection";
import { SubscriptionBlocks } from "./subscription-blocks";
import { Features } from "./features";
import { SubscriptionPlaylist } from "./subscription-playlist";
import { SubscriptionExplained } from "./subscription-explained";
import { Faq } from "./faq";
// import "./subscription-page.m.css";

export const GiftSubscription = props => (
  <div>
    <SubscriptionBlocks {...props} gift={true} />
    <div>
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      <br /><br /><br /><br /><br />
      <Features />
    </div>
    <SubscriptionTestimonial {...props} />
    <br />
    <SubscriptionCollection {...props} />
    <SubscriptionPlaylist />
    <SubscriptionExplained {...props} />
    <Faq />
  </div>
);

GiftSubscription.propTypes = {
  config: PropTypes.object
};
